import validator from 'validator';

const nameRegex = new RegExp("[\\p{L}\\s\\-']+", 'u');

export function strIsValidName(str: string, length?: number): boolean {
  if (!str) {
    return false;
  }

  if (length && !strHasMinLength(str, length)) {
    return false;
  }

  // Allows letters (any alphabet), spaces, hyphens, apostrophes
  return nameRegex.exec(str)?.[0].length === str.length;
}

export function strHasMinLength(str: string, length: number): boolean {
  if (length > 0) {
    if (!str) {
      return false;
    }
    if (str.length >= length) {
      return true;
    }
    return false;
  }
  return true;
}

export function strHasMaxLength(str: string, length: number): boolean {
  if (length > 0) {
    if (!str) {
      return true;
    }
    if (str.length <= length) {
      return true;
    }
    return false;
  }
  return true;
}

export function strHasUpper(str: string): boolean {
  if (!str) {
    return false;
  }
  return str !== str.toLowerCase();
}

export function strHasLower(str: string): boolean {
  if (!str) {
    return false;
  }
  return str !== str.toUpperCase();
}

export function strHasNumber(str: string): boolean {
  if (!str) {
    return false;
  }
  return /\d/.test(str);
}

export function strHasSpecial(str: string): boolean {
  if (!str) {
    return false;
  }
  const format = /[^A-Za-z0-9]/;
  return format.test(str);
}

export function strIsEmail(str: string): boolean {
  if (!str) {
    return false;
  }
  return validator.isEmail(str);
}

export function strIsPhone(s: string): boolean {
  if (!s) {
    return false;
  }

  // these are the validations from the backend
  if (s.length > 50) {
    return false;
  }

  const re = /^$|^[+]?[0-9]+([x][0-9]+)?$/;
  return re.test(s);
}

export function clearNumber(number: string): string {
  if (!number) {
    return number;
  }
  return number.replace(/\s+/g, '');
}

export function clearPhoneNumber(number: string): string {
  if (!number) {
    return number;
  }

  // Remove all whitespaces - ( )
  return number.replace(/[\s\-()]/g, "");
}

export function formatCreditCard(input?: string): string {
  if (!input) {
    return '';
  }
  return input.replace(/(.{4})/g, '$1 ');
}

export function obfuscateCardNumber(cardNumber: string): string {
  const digits = cardNumber.replace(/\D/g, "");
  const last4 = digits.slice(-4);
  return `**** **** **** ${last4}`;
}
